import React, { useEffect, useState, useMemo } from 'react'
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Row, Col, Button } from 'reactstrap'
import { MaterialReactTable } from 'material-react-table';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllReservation } from '../../slices/reservations/thunk';
import { getAllStation } from '../../slices/stations/thunk';
import { fetchCustomerListForReservation } from '../../slices/reservations/customerlist/thunk';
import { Loader } from '../Utils/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { setSuccessMessage, setEditSuccessMessage } from '../../slices/toastMessage/action';
import moment from 'moment';
import useReservationColumns from './constants/coloumn';
import { PAGE_TITLES } from '../Common/constants';
import { useColumnSettings } from '../Utils/useColumnSettings';
import { getView } from '../../slices/View/thunk';
import { hasPermission } from '../Utils/UtilityFunctions';

function ReservationListings() {
    const dispatch = useDispatch();
    const [station, setStation] = useState([])
    const [loading, setLoading] = useState(false)
    const allStationData = [];
    const allDate = [];
    const allName = [];
    const allNumber = [];
    const allstationadress = [];
    const allstationName = [];
    var flag = 0;
    var Stationflag = 0;
    var Stationflags = 0;
    const startDuration = [];
    const allDate1 = [];
    const endDuration = [];
    useEffect(() => {
        dispatch(getAllReservation())
        dispatch(getAllStation(setLoading))
        dispatch(fetchCustomerListForReservation(setLoading))
        dispatch(getView(setLoading));
    }, [dispatch])
    const reservation = useSelector((state) => state.Reservations.reservations)
    const stationData = useSelector((state) => state.Stations.station)
    const allres = useSelector((state) => state.CustomerAllData.customerListForReservation)
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage)
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const reservationPermission = hasPermission(permissionsMap, "reservation", "reservation")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")
    useEffect(() => {
        stationData.forEach((anotherElement) => {
            allStationData.push(anotherElement);
        })
        setStation(allStationData);
    }, [stationData])
    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
    });
    const handleExportData = () => {
        const csv = generateCsv(csvConfig)(reservation);
        download(csvConfig)(csv);
    };
    const finalData = reservation.map((reservationItem, index) => {
        const startTimeMoment = moment.utc(reservationItem.StartTime);
        const endTimeMoment = moment.utc(reservationItem.EndTime);
        const startDate = startTimeMoment.format('D MMMM YYYY');
        const endDate = endTimeMoment.format('D MMMM YYYY');
        const startDurationValue = startTimeMoment.format('hh:mm A');
        const endDurationValue = endTimeMoment.format('hh:mm A');
        const customerData = allres.find(customer => customer.CustomerId === reservationItem.CustomerId);
        const stationData = station.find(stationItem => stationItem.stationDetails.stationID === reservationItem.StationId);
        return {
            reservationId: reservationItem.ReservationId,
            customerName: customerData?.FirstName || '',
            phoneNumber: customerData?.Mobile || '',
            stationNameAndAddress: stationData?.stationDetails.address || '',
            duration: `${startDurationValue} - ${endDurationValue}`,
            date: startDate,
            connectorType: reservationItem.ConnectorType,
            evseId: reservationItem.EvseId,
        };
    });
    reservation.forEach((res, index) => {
        const DateObj = moment(res.StartTime);
        const endDate = DateObj.format('D MMM YYYY');
        allDate[index] = endDate;
        startDuration[index] = DateObj.format('hh:mm A');
        const DateObj1 = moment(res.EndTime);
        const endDate1 = DateObj1.format('D MMM YYYY');
        allDate1[index] = endDate1;
        endDuration[index] = DateObj1.format('hh:mm A');
        flag = 0;
        Stationflag = 0;
        allres.forEach(customer => {
            if (res.CustomerId === customer.CustomerId) {
                flag = 1;
                allName[index] = customer?.Name || '-';
                allNumber[index] = customer.Mobile || '-';
            }
        });
        station.forEach(stationItem => {
            const matchingReservation = res.StationId === stationItem.stationDetails.stationID;
            if (matchingReservation) {
                if ("address" in stationItem.stationDetails) {
                    Stationflag = 1;
                    allstationadress[index] = stationItem.stationDetails.address;
                }
                if ("name" in stationItem.stationDetails) {
                    Stationflags = 1;
                    allstationName[index] = stationItem.stationDetails.name;
                }
            }
        });
        if (flag === 0) {
            allName[index] = "-";
            allNumber[index] = "-";
        }
        if (Stationflag === 0) {
            allstationadress[index] = "-";
        }
        if (Stationflags === 0) {
            allstationName[index] = '-';
        }
    });
    const navigate = useNavigate()
    const navigateToEdit = async (id) => {
        let path = `/update-reservation/${id.original.reservationId}`
        navigate(path)
    }
    const navigateToView = async (id) => {
        let path = `/view-reservation/${id.original.reservationId}`
        navigate(path)
    }
    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Reservation Created Successfully`);
            dispatch(setSuccessMessage(false))
        }
        if (showEditSuccessMessage) {
            toast.success(`Reservation Updated Successfully`);
            dispatch(setEditSuccessMessage(false))
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch])
    const columns = useReservationColumns(allDate, allName, allNumber, allstationadress, startDuration, endDuration, allstationName, finalData, allres);

    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        CustomViewModal,
    } = useColumnSettings('reservation', columns);

    return (
        <React.Fragment>
            <div id='csms' className='page-content'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.RESERVATION_LIST} pageTitle={PAGE_TITLES.RESERVATION} />
                    <ToastContainer position='top-center' />
                    <Row>
                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                      <div className="d-flex flex-column flex-md-row">
                                        <h5 className="rv-page-title p-1">
                                          {"Reservation List"}
                                        </h5>
                                      </div>
                                      <div className="d-flex align-items-center">
                                        {reservationPermission && reservationPermission?.has("export") &&
                                          <Button color="secondary" className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={handleExportData}>
                                            <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2 fw-bold"></i>
                                            <span className="px-2 ps-3 ms-2 me-1 fw-bold">Export</span>
                                          </Button>}
                                        {reservationPermission && reservationPermission?.has('create') && <Button color="secondary" className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={() => { navigate("/create-reservation") }}>
                                          <i className="ri-add-fill label-icon align-middle fs-16 me-1 fw-bold"></i>
                                          <span className="ps-2 ms-2 me-1 fw-bold">
                                            {"Add Reservation"}
                                          </span>
                                        </Button>}
                                        {viewPermission && viewPermission?.has("view") &&
                                          <div
                                            color="secondary"
                                            className="btn-icon cursor-img"
                                            onClick={toggleSettingsModal}
                                          >
                                            <i className="ri-settings-2-line fs-4"></i>
                                          </div>}
                                      </div>
                                    </div>
                        <Col lg={12}>
                            <div className="listingjs-table " id="customerList">
                                        <div className="mb-3 mt-1 mx-1 border table-responsive">
                                            {loading && (<Loader />)}
                                            {reservation ?
                                                <MaterialReactTable
                                                    columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                                    data={finalData}
                                                    enableColumnOrdering={false}
                                                    enableColumnDragging={false}
                                                    enableTopToolbar={false}
                                                    enableColumnActions={true}
                                                    enableRowActions
                                                    enableDensityToggle={false}
                                                    displayColumnDefOptions={{
                                                        'mrt-row-actions': {
                                                            header: '',
                                                            enableHiding: true,
                                                            size: 52,
                                                            grow: true
                                                        },
                                                    }}
                                                    defaultColumn={{
                                                        minSize: 10,
                                                        maxSize: 9001,
                                                        muiTableBodyCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        },
                                                        muiTableHeadCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        }
                                                    }}
                                                    // layoutMode='grid'
                                                   renderRowActionMenuItems={({ closeMenu, row }) =>
                                                        [
                                                            reservationPermission && reservationPermission?.has('view') ? <MenuItem key="view" onClick={() => { navigateToView(row) }}>
                                                                <i className="ri-eye-line me-2" />
                                                                View
                                                            </MenuItem> : null,
                                                            reservationPermission && reservationPermission?.has('update') ? <MenuItem key="edit" onClick={() => { navigateToEdit(row) }}>
                                                                <i className="ri-edit-box-line  me-2" />
                                                                Edit
                                                            </MenuItem> : null,
                                                        ]
                                                    }
                                                />
                                                : null
                                            }
                                        </div>
                                    
                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default ReservationListings;